import {authService} from "../../client/connection/services/AuthService.js";
import {userService} from "../../client/connection/services/UserService.js";
import {UserPreferencesStore, TopUpPaymentStore, PaymentStore, SubscriptionStore, DonationStore} from "../State";
import {iFrameConnection} from "./IFrameConnection";
import {IFrameMessages} from "../../blink-sdk/messaging/IFrameMessages";
import {iFrameState} from "./IFrameState";
import {isDeepEqual, isString} from "../UtilsLib";
import {apiUpdatePreferences} from "../../client/state/UserPreferencesStore";
import {Dispatchable} from "../../stem-core/src/base/Dispatcher";
import {iFrameMerchantService} from "./IframeMerchantService";
import {iFrameUserDataService} from "./IFrameUserDataService";
import {MerchantAudienceMemberStore} from "../../client/state/merchant/MerchantAudienceMemberStore";
import {TimeUnit} from "../../stem-core/src/time/Duration";
import {EMPTY_USER_DATA, TNR_ALIAS} from "../../blink-sdk/Constants";
import {MerchantUserStore} from "../../client/state/merchant/MerchantUserStore";
import {StemDate} from "../../stem-core/src/time/Date.js";


// TODO: Rename this. Maybe split the functionality.
class IFrameBlinkService extends Dispatchable {
    lastSdkUserData = null;

    init() {
        this.updateSdkUserData();
        this.addListeners();
        this.addConnectionDispatchers();
    }

    addListeners() {
        // We need the sdk user data to be updated when we get all those flow checkpoint events. That is why we can't
        // rely on the iFrameUserDataService which sends those change events in an desynchronized way.
        const pushDataToSDK = () => this.updateSdkUserData();

        SubscriptionStore.addChangeListener(pushDataToSDK);
        DonationStore.addChangeListener(pushDataToSDK);
        UserPreferencesStore.addChangeListener(pushDataToSDK);
        MerchantUserStore.addChangeListener(pushDataToSDK);
        MerchantAudienceMemberStore.addChangeListener(pushDataToSDK)

        iFrameUserDataService.addChangeListener(pushDataToSDK);
        iFrameState.addChangeListener(pushDataToSDK);

        authService.onAuthenticationChange(pushDataToSDK);
    }

    addConnectionDispatchers() {
        TopUpPaymentStore.addCreateListener(topUp => this.showPaymentAnimation(topUp.getAmount()));
        PaymentStore.addCreateListener(purchase => this.showPaymentAnimation(purchase.getDebitedAmount()));
    }

    updateSdkUserData() {
        const sdkUserData = this.getSdkUserData();
        if (isDeepEqual(sdkUserData, this.lastSdkUserData)) {
            return;
        }
        this.lastSdkUserData = sdkUserData;
        iFrameConnection.sendToSDK(IFrameMessages.UPDATE_SDK_USER_DATA, {userData: sdkUserData});
    }

    getSerializedSubscription() {
        const subscription = iFrameUserDataService.getActiveSubscription();
        if (subscription) {
            return subscription.serializeForSDK();
        }
        const emailAddress = userService.getUserEmail();
        // TODO @flow Subscription rules based on email.
        if (iFrameMerchantService.isMerchant(TNR_ALIAS) && isString(emailAddress) && emailAddress.indexOf("@tnr.com") >= 0) {
            const fakeSubscriptionStartDate = Date.now();

            return {
                id: "fake-tnr",
                currencyCode: "usd",
                deliveryAddressId: null,
                blinkSignature: null,
                nextPaymentAttempt: null,
                userId: userService.getUserId(),
                amount: 20000000,
                createdAt: (new StemDate(fakeSubscriptionStartDate)).format(),
                canceledAt: null,
                activeUntil: (new StemDate(fakeSubscriptionStartDate)).addUnit(TimeUnit.MONTH).format(),
            };
        }
        return null;
    }

    getSdkUserData() {
        const defaultSdkUserData = EMPTY_USER_DATA;
        const userId = userService.getUserId();
        const preferences = UserPreferencesStore.getPreferences();
        const merchantUser = MerchantUserStore.getByUserAndMerchant(userId, iFrameMerchantService.merchantId);

        if (!authService.isAuthenticated() || !preferences) {
            return defaultSdkUserData;
        }

        const {showOnboarding} = preferences;
        if (showOnboarding) {
            apiUpdatePreferences({showOnboarding: false}).then();
        }

        const activeRecurringDonation = iFrameUserDataService.getActiveRecurringDonation();
        const latestOneTimeDonation = iFrameUserDataService.getLatestOneTimeDonation();
        const activeNewsletters = MerchantAudienceMemberStore.filter(member => member.isSubscribed() && member.merchantId === iFrameMerchantService.merchantId);

        // When adding a field here you should also add one in EMPTY_USER_DATA, for unauthenticated users
        return {
            userId,
            alwaysShowBalance: preferences.shouldShowBalanceInline(),
            subscription: this.getSerializedSubscription(),
            showOnboarding,
            activeRecurringDonation: activeRecurringDonation?.serializeForSDK(),
            latestOneTimeDonation: latestOneTimeDonation?.serializeForSDK(),
            activeNewsletters: activeNewsletters.map(audienceMember => audienceMember.serializeForSDK()),
            newsletterIds: activeNewsletters.map(newsletterMember => newsletterMember.audienceId),
            metadata: merchantUser?.metadata || {},
        };
    }

    showPaymentAnimation(paymentAmount) {
        const userPreferences = UserPreferencesStore.getPreferences();
        if (paymentAmount.getAmount() > 0 && userPreferences?.showPaymentAnimation) {
            iFrameConnection.sendToSDK(IFrameMessages.SESSION_PAYMENT_MADE);
        }
    }
}

export const iFrameBlinkService = new IFrameBlinkService();
